// extracted by mini-css-extract-plugin
export var bgColor = "styles-module--bgColor--87a33";
export var column = "styles-module--column--995ed";
export var columnText = "styles-module--columnText--20292";
export var featureSection = "styles-module--featureSection--e2c17";
export var featured = "styles-module--featured--14e8d";
export var fixedButton = "styles-module--fixedButton--2fa11";
export var marginTopSpecial = "styles-module--marginTopSpecial--7aa49";